import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import ApiCallServices from "../../../../../services/ApiCallServices";
import { END_POINTS } from "../../../../../services/endpoint/endPoint";
import button from "../../../../button.module.css";
import SegmentsList from "./child/SegmentsList";

const Segments = () => {
  const initialState = {
    id: null,
    name: "",
    parent_id: 0,
    geo_id: "",
  };

  const [tableData, setTableData] = useState([]);
  const [newSegments, setNewSegments] = useState(initialState);
  const [geoList, setGeoList] = useState([]);
  const [segmentList, setSegmentList] = useState([]);
  const [search, setSearch] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [errors, setErrors] = useState({});
  const [showHideModal, setShowHideModal] = useState(false);
  const [showHideModal1, setShowHideModal1] = useState(false);

  const [loader, setLoader] = useState(false);
  const [sortingColumn, setSortingColumn] = useState(null);
  const [sortingOrder, setSortingOrder] = useState("asc");

  const getSegmentById = async (id) => {
    try {
      const res = await ApiCallServices.getlisting(
        `${END_POINTS.getSegmentsById}/${id}`
      );
      if (res.status === 200) {
        const data = res.data.data;
        setNewSegments({
          id: data.id,
          name: data.name || "",
          parent_id: data.parent_id || "",
          geo_id: data.geo_id || "",
        });
        setIsEditMode(true);
        setShowHideModal(true);
        document.body.style.overflow = "hidden";
      }
    } catch (err) {
      toast.error("Failed to fetch segment data");
    }
  };

  const getSegmentsTableData = async () => {
    setLoader(true);
    try {
      const res = await ApiCallServices.create(END_POINTS.segmentssTableData, {
        name: search,
        sortingcolumn: sortingColumn,
        sortingorder: sortingOrder,
      });
      if (res.status === 200) {
        setTableData(res.data.data);
      }
    } catch (err) {
      toast.error("Failed to fetch segments");
    } finally {
      setLoader(false);
    }
  };

  const updateStatus = async (id, status) => {
    try {
      const res = await ApiCallServices.create(
        END_POINTS.updateSegmentsStatus,
        { id, status }
      );
      if (res.status === 200) {
        toast.success(res.data.message || "Status updated");
        getSegmentsTableData();
      }
    } catch (err) {
      toast.error("Failed to update status");
    }
  };

  const handleInput = async (e) => {
    const { name, value } = e.target;

    if (name === "parent_id") {
      setNewSegments((prev) => ({ ...prev, parent_id: value }));

      if (value) {
        try {
          const res = await ApiCallServices.getlisting(
            `${END_POINTS.getSegmentsById}/${value}`
          );
          if (res.status === 200) {
            const parentGeo = res.data.data.geo_id;
            setNewSegments((prev) => ({
              ...prev,
              geo_id: parentGeo,
            }));
          }
        } catch (err) {
          toast.error("Failed to fetch parent segment geo");
        }
      } else {
        // Clear geo_id if parent is removed
        setNewSegments((prev) => ({
          ...prev,
          geo_id: "",
        }));
      }

      return;
    }

    if (name === "geo_id") {
      setNewSegments((prev) => ({ ...prev, geo_id: value, parent_id: "" }));

      try {
        const res = await ApiCallServices.create(
          END_POINTS.segmentssTableData,
          {
            name: "",
            geo_id: value, // Send geo_id to filter segments
          }
        );
        if (res.status === 200) {
          setSegmentList(res.data.data || []);
        }
      } catch (err) {
        toast.error("Failed to fetch segments for selected country");
      }

      return;
    }

    setNewSegments((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    const errors = {};
    if (!newSegments.name) errors.name = "Name is required";
    if (!newSegments.geo_id) errors.geo_id = "Geo ID is required";
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const payload = {
        ...newSegments,
        parent_id:
          newSegments.parent_id === "" || newSegments.parent_id === null
            ? 0
            : newSegments.parent_id,
      };

      const apiFn = isEditMode
        ? END_POINTS.updateSegments
        : END_POINTS.createSegments;
      const res = await ApiCallServices.create(apiFn, payload);
      if (res.status === 200) {
        toast.success(res.data.message || "Operation successful");
        resetForm();
        getSegmentsTableData();
      }
    } catch (err) {
      toast.error(err.response?.data?.error || "Operation failed");
    }
  };

  const resetForm = () => {
    setIsEditMode(false);
    setNewSegments(initialState);
    setShowHideModal(false);
    document.body.removeAttribute("style");
    setErrors({});
  };

  const getGeoList = async () => {
    try {
      const res = await ApiCallServices.getlisting(
        END_POINTS.countryList + "?segmentStatus=1"
      );
      if (res.status === 200) {
        setGeoList(res.data.data);
      }
    } catch (err) {
      toast.error("Failed to load geo list");
    }
  };

  const getSegmentList = async () => {
    try {
      const res = await ApiCallServices.create(END_POINTS.segmentssTableData, {
        name: "",
      });
      if (res.status === 200) {
        setSegmentList(res.data.data || []);
      }
    } catch (err) {
      toast.error("Failed to load segments");
    }
  };

  useEffect(() => {
    getGeoList();
    getSegmentList();
    getSegmentsTableData();
  }, [search, sortingColumn, sortingOrder]);

  const deleteSegment = async (id) => {
    if (
      !window.confirm(
        "Are you sure you want to delete this segment? This will also remove its publishers and reach for this segment."
      )
    ) {
      return;
    }

    try {
      const res = await ApiCallServices.create(END_POINTS.deleteSegments, {
        id,
      });
      if (res.status === 200) {
        toast.success(res.data.message || "Segment deleted successfully");
        getSegmentsTableData();
      }
    } catch (err) {
      toast.error(err.response?.data?.error || "Failed to delete segment");
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="container-fluid">
      <div className='filter-wraper justify-content-between'>
          <div className='d-flex align-items-center fields'>
              <h3>Maange Segments</h3>
          </div>
      </div>


        <div className="filter-wraper d-flex justify-content-between">
          <div className="form-group search-icon">
            <input
              type="text"
              className="form-control"
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search segment"
            />
          </div>
          <div>
            <button
              className={`${button.btn} ${button.btnDarkBlue}`}
              onClick={() => {
                setShowHideModal(true);
                document.body.style.overflow = "hidden";
              }}
            >
              Add New Segment
            </button>
          </div>
        </div>

        <SegmentsList
          tableData={tableData}
          getSegments={getSegmentById}
          search={search}
          deleteSegment={deleteSegment}
          onSort={(col) => {
            if (col === sortingColumn) {
              setSortingOrder((prev) => (prev === "asc" ? "desc" : "asc"));
            } else {
              setSortingColumn(col);
              setSortingOrder("asc");
            }
          }}
          sortingColumn={sortingColumn}
          sortingOrder={sortingOrder}
          updateStatus={updateStatus}
          loader={loader}
        />
      </div>

      <div className={`modal form-modal ${showHideModal ? "show" : ""}`}>
        <div className="modal-dialog modal-md modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                {isEditMode ? "Update Segment" : "Create Segment"}
              </h4>
              <i
                className="fa-regular fa-circle-xmark close-icon"
                onClick={resetForm}
              ></i>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="form-wraper">
                  <div className="form-group">
                    <label>Country *</label>
                    <select
                      name="geo_id"
                      value={newSegments.geo_id}
                      onChange={handleInput}
                      disabled={newSegments?.parent_id}
                      className="form-control"
                    >
                      <option value="">-- Select Country --</option>
                      {geoList.map((geo) => (
                        <option key={geo.ccode} value={geo.ccode}>
                          {geo.name}
                        </option>
                      ))}
                    </select>
                    {errors.geo_id && (
                      <div className="input-error">{errors.geo_id}</div>
                    )}
                  </div>
                  <div className="form-group">
                    <label>Parent Segment (optional)</label>
                    <select
                      name="parent_id"
                      value={newSegments.parent_id || ""}
                      onChange={handleInput}
                      className="form-control"
                    >
                      <option value="">-- Select Parent --</option>
                      {segmentList?.filter((seg) => seg.parent_id === 0)?.map((seg) => (
                        <option key={seg.id} value={seg.id}>
                          {seg.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Segment/Child Name *</label>
                    <input
                      name="name"
                      value={newSegments.name}
                      onChange={handleInput}
                      className="form-control"
                      placeholder="Enter segment name"
                    />
                    {errors.name && (
                      <div className="input-error">{errors.name}</div>
                    )}
                  </div>

                  <div className="text-end">
                    <button
                      type="submit"
                      className={`${button.btn} ${button.btnBlue}`}
                    >
                      {isEditMode ? "Update" : "Save"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`${showHideModal || showHideModal1 ? "overlay" : ""}`}
      ></div>
    </>
  );
};

export default Segments;
